var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "md-switch",
    {
      staticClass: "custom-switch",
      attrs: { "data-test-id": "switch" },
      on: {
        change: function($event) {
          return _vm.$emit("switchChange", _vm.switchValue)
        }
      },
      model: {
        value: _vm.switchValue,
        callback: function($$v) {
          _vm.switchValue = $$v
        },
        expression: "switchValue"
      }
    },
    [_vm._v("\n  " + _vm._s(_vm.label) + "\n")]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6e5a6fb6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6e5a6fb6","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/vue/common/UI/SwitchWrapper.vue
// module id = PXzt
// module chunks = 1